import { RegionAppPath } from '@gap/utils/region-utils'

const EU_PATH = new RegExp(`^/${RegionAppPath.eu}(?=/|$)`, 'i')

/**
 * Returns the AU equivalent of an EU URL on a single-region stage, or undefined when no redirect is needed.
 * @param params.isMultiRegion whether this stage serves the EU region
 * @param params.location the current pathname, search and hash
 * @returns the URL to load instead, or undefined
 */
export function singleRegionRedirectTarget(params: {
   isMultiRegion: boolean
   location: Pick<Location, 'pathname' | 'search' | 'hash'>
}): string | undefined {
   const { isMultiRegion, location } = params
   if (isMultiRegion || !EU_PATH.test(location.pathname)) return undefined
   return location.pathname.replace(EU_PATH, `/${RegionAppPath.au}`) + location.search + location.hash
}
